import React from 'react';
import { Button, CircularProgress } from '@mui/material';

interface LoadingButtonProps {
  isLoading: boolean;
  loadingText: string;
  defaultText: string;
  onClick: () => void;
  variant?: 'text' | 'outlined' | 'contained';
  color?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
  startIcon?: React.ReactNode;
  'data-qa-id'?: string;
  ariaLabel?: string;
}

const LoadingButton = ({
  isLoading,
  loadingText,
  defaultText,
  onClick,
  variant = 'contained',
  color = 'primary',
  startIcon,
  'data-qa-id': dataQaId,
  ariaLabel,
}: LoadingButtonProps) => (
  <Button
    color={color}
    variant={variant}
    disableElevation
    onClick={onClick}
    startIcon={startIcon}
    data-qa-id={dataQaId}
    aria-label={ariaLabel || (isLoading ? loadingText : defaultText)}
  >
    {isLoading && (
      <>
        <CircularProgress
          aria-label={loadingText}
          aria-live="polite"
          aria-busy={isLoading}
          color="inherit"
          size="20px"
          sx={{ marginRight: 1 }}
        />
        {loadingText}
      </>
    )}
    {!isLoading && defaultText}
  </Button>
);

export default LoadingButton;
